/**
 * The roles specific to the application which may be contained
 * in the access token of a user.
 */
export class Roles {
  public static readonly LIO_DZ_FUSION: string = 'LIO_DZ_Fusion';
  public static readonly LIO_DZ_READONLY: string = 'LIO_DZ_ReadOnly';
  public static readonly LIO_DZ_SUPPORT: string = 'LIO_DZ_Support';
  public static readonly LIO_DZ_SYSADMIN: string = 'LIO_DZ_SysAdmin';
  public static readonly LIO_DZ_TRADER_1: string = 'LIO_DZ_Trader_1';
  public static readonly LIO_DZ_TRADER_2: string = 'LIO_DZ_Trader_2';
  public static readonly LIO_SUPER: string = 'LIO_SUPER';
  public static readonly LIO_VR_READONLY: string = 'LIO_VR_ReadOnly';
  public static readonly LIO_VR_REFI: string = 'LIO_VR_Refi';
  public static readonly LIO_VR_TRADER_1: string = 'LIO_VR_Trader_1';

  public static readonly LICO_READER: string = 'LICO_READER';
  public static readonly LICO_TRADER: string = 'LICO_TRADER';
  public static readonly LIO_FK_DZ_TRADER: string = 'LIO_FK_DZ_Trader';
  public static readonly LIO_FK_DZ_LIMIT_ADMIN: string = 'LIO_FK_DZ_LIMIT_Admin';
  public static readonly LIO_FK_DZ_LIMIT_READONLY: string = 'LIO_FK_DZ_LIMIT_ReadOnly';

  public static readonly PERMIT_ALL: string = '*';

  public static readonly DZ_ROLES: string[] = [
    Roles.LIO_DZ_FUSION,
    Roles.LIO_DZ_READONLY,
    Roles.LIO_DZ_SUPPORT,
    Roles.LIO_DZ_SYSADMIN,
    Roles.LIO_DZ_TRADER_1,
    Roles.LIO_DZ_TRADER_2,
    Roles.LIO_FK_DZ_TRADER,
    Roles.LIO_FK_DZ_LIMIT_ADMIN,
    Roles.LIO_FK_DZ_LIMIT_READONLY
  ];

  public static readonly VR_ROLES: string[] = [Roles.LIO_VR_READONLY, Roles.LIO_VR_REFI, Roles.LIO_VR_TRADER_1];
}
